/* 
 * Export component file to be used on project
*/

import ModalUploadMedicalRequest from './ModalUploadMedicalRequest.js';
export default ModalUploadMedicalRequest;
